import { render } from "./SectionAboutWelcomeMap.vue?vue&type=template&id=cecbe21c&scoped=true"
import script from "./SectionAboutWelcomeMap.vue?vue&type=script&lang=js"
export * from "./SectionAboutWelcomeMap.vue?vue&type=script&lang=js"

import "./SectionAboutWelcomeMap.vue?vue&type=style&index=0&id=cecbe21c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cecbe21c"]])

export default __exports__